import { useEffect } from "react";
import { animate, stagger } from "animejs";
import { shouldReduceMotion } from "../utils/motion";

const useAnimeReveal = (rootRef, selector = "[data-reveal]", deps = []) => {
  useEffect(() => {
    const root = rootRef.current;
    if (!root || shouldReduceMotion()) return undefined;

    const elements = Array.from(root.querySelectorAll(selector));
    if (!elements.length) return undefined;

    elements.forEach((element) => {
      element.style.opacity = "0";
      element.style.transform = "translate3d(0, 28px, 0)";
    });

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .map((entry) => entry.target);

        if (!visible.length) return;

        animate(visible, {
          opacity: [0, 1],
          translateY: [28, 0],
          duration: 760,
          delay: stagger(70),
          ease: "outExpo"
        });

        visible.forEach((element) => observer.unobserve(element));
      },
      {
        threshold: 0.18,
        rootMargin: "0px 0px -80px 0px"
      }
    );

    elements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export default useAnimeReveal;
